var _g, _defs;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var s = Object.getOwnPropertySymbols(e); for (r = 0; r < s.length; r++) o = s[r], t.includes(o) || {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (e.includes(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgQrCode(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 160,
    height: 160,
    viewBox: "0 0 160 160",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clip0_613_20443)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M160 0H0V160H160V0Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M14.8276 10H10V14.8276H14.8276V10Z",
    fill: "black"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M19.6552 10H14.8276V14.8276H19.6552V10Z",
    fill: "black"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M24.4828 10H19.6552V14.8276H24.4828V10Z",
    fill: "black"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M29.3103 10H24.4828V14.8276H29.3103V10Z",
    fill: "black"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M34.1379 10H29.3103V14.8276H34.1379V10Z",
    fill: "black"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M38.9655 10H34.1379V14.8276H38.9655V10Z",
    fill: "black"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M43.7931 10H38.9655V14.8276H43.7931V10Z",
    fill: "black"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M53.4483 10H48.6207V14.8276H53.4483V10Z",
    fill: "black"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M58.2759 10H53.4483V14.8276H58.2759V10Z",
    fill: "black"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M63.1035 10H58.2759V14.8276H63.1035V10Z",
    fill: "black"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M72.7586 10H67.931V14.8276H72.7586V10Z",
    fill: "black"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M87.2414 10H82.4138V14.8276H87.2414V10Z",
    fill: "black"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M92.069 10H87.2414V14.8276H92.069V10Z",
    fill: "black"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M96.8966 10H92.069V14.8276H96.8966V10Z",
    fill: "black"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M101.724 10H96.8966V14.8276H101.724V10Z",
    fill: "black"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M106.552 10H101.724V14.8276H106.552V10Z",
    fill: "black"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M111.379 10H106.552V14.8276H111.379V10Z",
    fill: "black"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M121.034 10H116.207V14.8276H121.034V10Z",
    fill: "black"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M125.862 10H121.034V14.8276H125.862V10Z",
    fill: "black"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M130.69 10H125.862V14.8276H130.69V10Z",
    fill: "black"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M135.517 10H130.69V14.8276H135.517V10Z",
    fill: "black"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M140.345 10H135.517V14.8276H140.345V10Z",
    fill: "black"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M145.172 10H140.345V14.8276H145.172V10Z",
    fill: "black"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M150 10H145.172V14.8276H150V10Z",
    fill: "black"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M14.8276 14.8276H10V19.6552H14.8276V14.8276Z",
    fill: "black"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M43.7931 14.8276H38.9655V19.6552H43.7931V14.8276Z",
    fill: "black"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M58.2759 14.8276H53.4483V19.6552H58.2759V14.8276Z",
    fill: "black"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M87.2414 14.8276H82.4138V19.6552H87.2414V14.8276Z",
    fill: "black"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M92.069 14.8276H87.2414V19.6552H92.069V14.8276Z",
    fill: "black"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M96.8966 14.8276H92.069V19.6552H96.8966V14.8276Z",
    fill: "black"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M101.724 14.8276H96.8966V19.6552H101.724V14.8276Z",
    fill: "black"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M106.552 14.8276H101.724V19.6552H106.552V14.8276Z",
    fill: "black"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M111.379 14.8276H106.552V19.6552H111.379V14.8276Z",
    fill: "black"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M121.034 14.8276H116.207V19.6552H121.034V14.8276Z",
    fill: "black"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M150 14.8276H145.172V19.6552H150V14.8276Z",
    fill: "black"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M14.8276 19.6552H10V24.4828H14.8276V19.6552Z",
    fill: "black"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M24.4828 19.6552H19.6552V24.4828H24.4828V19.6552Z",
    fill: "black"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M29.3103 19.6552H24.4828V24.4828H29.3103V19.6552Z",
    fill: "black"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M34.1379 19.6552H29.3103V24.4828H34.1379V19.6552Z",
    fill: "black"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M43.7931 19.6552H38.9655V24.4828H43.7931V19.6552Z",
    fill: "black"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M67.931 19.6552H63.1035V24.4828H67.931V19.6552Z",
    fill: "black"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M72.7586 19.6552H67.931V24.4828H72.7586V19.6552Z",
    fill: "black"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M77.5862 19.6552H72.7586V24.4828H77.5862V19.6552Z",
    fill: "black"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M82.4138 19.6552H77.5862V24.4828H82.4138V19.6552Z",
    fill: "black"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M87.2414 19.6552H82.4138V24.4828H87.2414V19.6552Z",
    fill: "black"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M96.8966 19.6552H92.069V24.4828H96.8966V19.6552Z",
    fill: "black"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M101.724 19.6552H96.8966V24.4828H101.724V19.6552Z",
    fill: "black"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M106.552 19.6552H101.724V24.4828H106.552V19.6552Z",
    fill: "black"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M111.379 19.6552H106.552V24.4828H111.379V19.6552Z",
    fill: "black"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M121.034 19.6552H116.207V24.4828H121.034V19.6552Z",
    fill: "black"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M130.69 19.6552H125.862V24.4828H130.69V19.6552Z",
    fill: "black"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M135.517 19.6552H130.69V24.4828H135.517V19.6552Z",
    fill: "black"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M140.345 19.6552H135.517V24.4828H140.345V19.6552Z",
    fill: "black"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M150 19.6552H145.172V24.4828H150V19.6552Z",
    fill: "black"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M14.8276 24.4828H10V29.3103H14.8276V24.4828Z",
    fill: "black"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M24.4828 24.4828H19.6552V29.3103H24.4828V24.4828Z",
    fill: "black"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M29.3103 24.4828H24.4828V29.3103H29.3103V24.4828Z",
    fill: "black"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M34.1379 24.4828H29.3103V29.3103H34.1379V24.4828Z",
    fill: "black"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M43.7931 24.4828H38.9655V29.3103H43.7931V24.4828Z",
    fill: "black"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M53.4483 24.4828H48.6207V29.3103H53.4483V24.4828Z",
    fill: "black"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M58.2759 24.4828H53.4483V29.3103H58.2759V24.4828Z",
    fill: "black"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M63.1035 24.4828H58.2759V29.3103H63.1035V24.4828Z",
    fill: "black"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M77.5862 24.4828H72.7586V29.3103H77.5862V24.4828Z",
    fill: "black"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M82.4138 24.4828H77.5862V29.3103H82.4138V24.4828Z",
    fill: "black"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M87.2414 24.4828H82.4138V29.3103H87.2414V24.4828Z",
    fill: "black"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M92.069 24.4828H87.2414V29.3103H92.069V24.4828Z",
    fill: "black"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M96.8966 24.4828H92.069V29.3103H96.8966V24.4828Z",
    fill: "black"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M121.034 24.4828H116.207V29.3103H121.034V24.4828Z",
    fill: "black"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M130.69 24.4828H125.862V29.3103H130.69V24.4828Z",
    fill: "black"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M135.517 24.4828H130.69V29.3103H135.517V24.4828Z",
    fill: "black"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M140.345 24.4828H135.517V29.3103H140.345V24.4828Z",
    fill: "black"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M150 24.4828H145.172V29.3103H150V24.4828Z",
    fill: "black"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M14.8276 29.3103H10V34.1379H14.8276V29.3103Z",
    fill: "black"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M24.4828 29.3103H19.6552V34.1379H24.4828V29.3103Z",
    fill: "black"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M29.3103 29.3103H24.4828V34.1379H29.3103V29.3103Z",
    fill: "black"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M34.1379 29.3103H29.3103V34.1379H34.1379V29.3103Z",
    fill: "black"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M43.7931 29.3103H38.9655V34.1379H43.7931V29.3103Z",
    fill: "black"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M53.4483 29.3103H48.6207V34.1379H53.4483V29.3103Z",
    fill: "black"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M58.2759 29.3103H53.4483V34.1379H58.2759V29.3103Z",
    fill: "black"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M63.1035 29.3103H58.2759V34.1379H63.1035V29.3103Z",
    fill: "black"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M67.931 29.3103H63.1035V34.1379H67.931V29.3103Z",
    fill: "black"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M82.4138 29.3103H77.5862V34.1379H82.4138V29.3103Z",
    fill: "black"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M101.724 29.3103H96.8966V34.1379H101.724V29.3103Z",
    fill: "black"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M111.379 29.3103H106.552V34.1379H111.379V29.3103Z",
    fill: "black"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M121.034 29.3103H116.207V34.1379H121.034V29.3103Z",
    fill: "black"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M130.69 29.3103H125.862V34.1379H130.69V29.3103Z",
    fill: "black"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M135.517 29.3103H130.69V34.1379H135.517V29.3103Z",
    fill: "black"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M140.345 29.3103H135.517V34.1379H140.345V29.3103Z",
    fill: "black"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M150 29.3103H145.172V34.1379H150V29.3103Z",
    fill: "black"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M14.8276 34.1379H10V38.9655H14.8276V34.1379Z",
    fill: "black"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M43.7931 34.1379H38.9655V38.9655H43.7931V34.1379Z",
    fill: "black"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M53.4483 34.1379H48.6207V38.9655H53.4483V34.1379Z",
    fill: "black"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M63.1035 34.1379H58.2759V38.9655H63.1035V34.1379Z",
    fill: "black"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M72.7586 34.1379H67.931V38.9655H72.7586V34.1379Z",
    fill: "black"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M92.069 34.1379H87.2414V38.9655H92.069V34.1379Z",
    fill: "black"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M101.724 34.1379H96.8966V38.9655H101.724V34.1379Z",
    fill: "black"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M111.379 34.1379H106.552V38.9655H111.379V34.1379Z",
    fill: "black"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M121.034 34.1379H116.207V38.9655H121.034V34.1379Z",
    fill: "black"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M150 34.1379H145.172V38.9655H150V34.1379Z",
    fill: "black"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M14.8276 38.9655H10V43.7931H14.8276V38.9655Z",
    fill: "black"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M19.6552 38.9655H14.8276V43.7931H19.6552V38.9655Z",
    fill: "black"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M24.4828 38.9655H19.6552V43.7931H24.4828V38.9655Z",
    fill: "black"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M29.3103 38.9655H24.4828V43.7931H29.3103V38.9655Z",
    fill: "black"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M34.1379 38.9655H29.3103V43.7931H34.1379V38.9655Z",
    fill: "black"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M38.9655 38.9655H34.1379V43.7931H38.9655V38.9655Z",
    fill: "black"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M43.7931 38.9655H38.9655V43.7931H43.7931V38.9655Z",
    fill: "black"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M53.4483 38.9655H48.6207V43.7931H53.4483V38.9655Z",
    fill: "black"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M63.1035 38.9655H58.2759V43.7931H63.1035V38.9655Z",
    fill: "black"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M72.7586 38.9655H67.931V43.7931H72.7586V38.9655Z",
    fill: "black"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M82.4138 38.9655H77.5862V43.7931H82.4138V38.9655Z",
    fill: "black"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M92.069 38.9655H87.2414V43.7931H92.069V38.9655Z",
    fill: "black"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M101.724 38.9655H96.8966V43.7931H101.724V38.9655Z",
    fill: "black"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M111.379 38.9655H106.552V43.7931H111.379V38.9655Z",
    fill: "black"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M121.034 38.9655H116.207V43.7931H121.034V38.9655Z",
    fill: "black"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M125.862 38.9655H121.034V43.7931H125.862V38.9655Z",
    fill: "black"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M130.69 38.9655H125.862V43.7931H130.69V38.9655Z",
    fill: "black"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M135.517 38.9655H130.69V43.7931H135.517V38.9655Z",
    fill: "black"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M140.345 38.9655H135.517V43.7931H140.345V38.9655Z",
    fill: "black"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M145.172 38.9655H140.345V43.7931H145.172V38.9655Z",
    fill: "black"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M150 38.9655H145.172V43.7931H150V38.9655Z",
    fill: "black"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M53.4483 43.7931H48.6207V48.6207H53.4483V43.7931Z",
    fill: "black"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M82.4138 43.7931H77.5862V48.6207H82.4138V43.7931Z",
    fill: "black"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M87.2414 43.7931H82.4138V48.6207H87.2414V43.7931Z",
    fill: "black"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M92.069 43.7931H87.2414V48.6207H92.069V43.7931Z",
    fill: "black"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M96.8966 43.7931H92.069V48.6207H96.8966V43.7931Z",
    fill: "black"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M111.379 43.7931H106.552V48.6207H111.379V43.7931Z",
    fill: "black"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M14.8276 48.6207H10V53.4483H14.8276V48.6207Z",
    fill: "black"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M19.6552 48.6207H14.8276V53.4483H19.6552V48.6207Z",
    fill: "black"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M24.4828 48.6207H19.6552V53.4483H24.4828V48.6207Z",
    fill: "black"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M34.1379 48.6207H29.3103V53.4483H34.1379V48.6207Z",
    fill: "black"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M43.7931 48.6207H38.9655V53.4483H43.7931V48.6207Z",
    fill: "black"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M53.4483 48.6207H48.6207V53.4483H53.4483V48.6207Z",
    fill: "black"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M72.7586 48.6207H67.931V53.4483H72.7586V48.6207Z",
    fill: "black"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M77.5862 48.6207H72.7586V53.4483H77.5862V48.6207Z",
    fill: "black"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M82.4138 48.6207H77.5862V53.4483H82.4138V48.6207Z",
    fill: "black"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M87.2414 48.6207H82.4138V53.4483H87.2414V48.6207Z",
    fill: "black"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M96.8966 48.6207H92.069V53.4483H96.8966V48.6207Z",
    fill: "black"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M101.724 48.6207H96.8966V53.4483H101.724V48.6207Z",
    fill: "black"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M106.552 48.6207H101.724V53.4483H106.552V48.6207Z",
    fill: "black"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M111.379 48.6207H106.552V53.4483H111.379V48.6207Z",
    fill: "black"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M116.207 48.6207H111.379V53.4483H116.207V48.6207Z",
    fill: "black"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M121.034 48.6207H116.207V53.4483H121.034V48.6207Z",
    fill: "black"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M125.862 48.6207H121.034V53.4483H125.862V48.6207Z",
    fill: "black"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M130.69 48.6207H125.862V53.4483H130.69V48.6207Z",
    fill: "black"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M135.517 48.6207H130.69V53.4483H135.517V48.6207Z",
    fill: "black"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M150 48.6207H145.172V53.4483H150V48.6207Z",
    fill: "black"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M19.6552 53.4483H14.8276V58.2759H19.6552V53.4483Z",
    fill: "black"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M24.4828 53.4483H19.6552V58.2759H24.4828V53.4483Z",
    fill: "black"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M34.1379 53.4483H29.3103V58.2759H34.1379V53.4483Z",
    fill: "black"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M53.4483 53.4483H48.6207V58.2759H53.4483V53.4483Z",
    fill: "black"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M58.2759 53.4483H53.4483V58.2759H58.2759V53.4483Z",
    fill: "black"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M77.5862 53.4483H72.7586V58.2759H77.5862V53.4483Z",
    fill: "black"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M92.069 53.4483H87.2414V58.2759H92.069V53.4483Z",
    fill: "black"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M96.8966 53.4483H92.069V58.2759H96.8966V53.4483Z",
    fill: "black"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M101.724 53.4483H96.8966V58.2759H101.724V53.4483Z",
    fill: "black"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M106.552 53.4483H101.724V58.2759H106.552V53.4483Z",
    fill: "black"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M121.034 53.4483H116.207V58.2759H121.034V53.4483Z",
    fill: "black"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M125.862 53.4483H121.034V58.2759H125.862V53.4483Z",
    fill: "black"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M130.69 53.4483H125.862V58.2759H130.69V53.4483Z",
    fill: "black"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M135.517 53.4483H130.69V58.2759H135.517V53.4483Z",
    fill: "black"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M145.172 53.4483H140.345V58.2759H145.172V53.4483Z",
    fill: "black"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M150 53.4483H145.172V58.2759H150V53.4483Z",
    fill: "black"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M14.8276 58.2759H10V63.1035H14.8276V58.2759Z",
    fill: "black"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M19.6552 58.2759H14.8276V63.1035H19.6552V58.2759Z",
    fill: "black"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M43.7931 58.2759H38.9655V63.1035H43.7931V58.2759Z",
    fill: "black"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M67.931 58.2759H63.1035V63.1035H67.931V58.2759Z",
    fill: "black"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M72.7586 58.2759H67.931V63.1035H72.7586V58.2759Z",
    fill: "black"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M77.5862 58.2759H72.7586V63.1035H77.5862V58.2759Z",
    fill: "black"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M92.069 58.2759H87.2414V63.1035H92.069V58.2759Z",
    fill: "black"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M106.552 58.2759H101.724V63.1035H106.552V58.2759Z",
    fill: "black"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M116.207 58.2759H111.379V63.1035H116.207V58.2759Z",
    fill: "black"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M125.862 58.2759H121.034V63.1035H125.862V58.2759Z",
    fill: "black"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M135.517 58.2759H130.69V63.1035H135.517V58.2759Z",
    fill: "black"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M14.8276 63.1035H10V67.931H14.8276V63.1035Z",
    fill: "black"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M19.6552 63.1035H14.8276V67.931H19.6552V63.1035Z",
    fill: "black"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M34.1379 63.1035H29.3103V67.931H34.1379V63.1035Z",
    fill: "black"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M38.9655 63.1035H34.1379V67.931H38.9655V63.1035Z",
    fill: "black"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M48.6207 63.1035H43.7931V67.931H48.6207V63.1035Z",
    fill: "black"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M53.4483 63.1035H48.6207V67.931H53.4483V63.1035Z",
    fill: "black"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M63.1035 63.1035H58.2759V67.931H63.1035V63.1035Z",
    fill: "black"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M67.931 63.1035H63.1035V67.931H67.931V63.1035Z",
    fill: "black"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M72.7586 63.1035H67.931V67.931H72.7586V63.1035Z",
    fill: "black"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M77.5862 63.1035H72.7586V67.931H77.5862V63.1035Z",
    fill: "black"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M82.4138 63.1035H77.5862V67.931H82.4138V63.1035Z",
    fill: "black"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M87.2414 63.1035H82.4138V67.931H87.2414V63.1035Z",
    fill: "black"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M96.8966 63.1035H92.069V67.931H96.8966V63.1035Z",
    fill: "black"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M101.724 63.1035H96.8966V67.931H101.724V63.1035Z",
    fill: "black"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M121.034 63.1035H116.207V67.931H121.034V63.1035Z",
    fill: "black"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M135.517 63.1035H130.69V67.931H135.517V63.1035Z",
    fill: "black"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M145.172 63.1035H140.345V67.931H145.172V63.1035Z",
    fill: "black"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M19.6552 67.931H14.8276V72.7586H19.6552V67.931Z",
    fill: "black"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M24.4828 67.931H19.6552V72.7586H24.4828V67.931Z",
    fill: "black"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M29.3103 67.931H24.4828V72.7586H29.3103V67.931Z",
    fill: "black"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M38.9655 67.931H34.1379V72.7586H38.9655V67.931Z",
    fill: "black"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M43.7931 67.931H38.9655V72.7586H43.7931V67.931Z",
    fill: "black"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M77.5862 67.931H72.7586V72.7586H77.5862V67.931Z",
    fill: "black"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M92.069 67.931H87.2414V72.7586H92.069V67.931Z",
    fill: "black"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M96.8966 67.931H92.069V72.7586H96.8966V67.931Z",
    fill: "black"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M101.724 67.931H96.8966V72.7586H101.724V67.931Z",
    fill: "black"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M111.379 67.931H106.552V72.7586H111.379V67.931Z",
    fill: "black"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M116.207 67.931H111.379V72.7586H116.207V67.931Z",
    fill: "black"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M145.172 67.931H140.345V72.7586H145.172V67.931Z",
    fill: "black"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M150 67.931H145.172V72.7586H150V67.931Z",
    fill: "black"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M48.6207 72.7586H43.7931V77.5862H48.6207V72.7586Z",
    fill: "black"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M53.4483 72.7586H48.6207V77.5862H53.4483V72.7586Z",
    fill: "black"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M58.2759 72.7586H53.4483V77.5862H58.2759V72.7586Z",
    fill: "black"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M63.1035 72.7586H58.2759V77.5862H63.1035V72.7586Z",
    fill: "black"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M67.931 72.7586H63.1035V77.5862H67.931V72.7586Z",
    fill: "black"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M72.7586 72.7586H67.931V77.5862H72.7586V72.7586Z",
    fill: "black"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M77.5862 72.7586H72.7586V77.5862H77.5862V72.7586Z",
    fill: "black"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M82.4138 72.7586H77.5862V77.5862H82.4138V72.7586Z",
    fill: "black"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M96.8966 72.7586H92.069V77.5862H96.8966V72.7586Z",
    fill: "black"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M111.379 72.7586H106.552V77.5862H111.379V72.7586Z",
    fill: "black"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M130.69 72.7586H125.862V77.5862H130.69V72.7586Z",
    fill: "black"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M135.517 72.7586H130.69V77.5862H135.517V72.7586Z",
    fill: "black"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M150 72.7586H145.172V77.5862H150V72.7586Z",
    fill: "black"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M34.1379 77.5862H29.3103V82.4138H34.1379V77.5862Z",
    fill: "black"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M43.7931 77.5862H38.9655V82.4138H43.7931V77.5862Z",
    fill: "black"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M77.5862 77.5862H72.7586V82.4138H77.5862V77.5862Z",
    fill: "black"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M92.069 77.5862H87.2414V82.4138H92.069V77.5862Z",
    fill: "black"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M96.8966 77.5862H92.069V82.4138H96.8966V77.5862Z",
    fill: "black"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M106.552 77.5862H101.724V82.4138H106.552V77.5862Z",
    fill: "black"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M111.379 77.5862H106.552V82.4138H111.379V77.5862Z",
    fill: "black"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M116.207 77.5862H111.379V82.4138H116.207V77.5862Z",
    fill: "black"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M121.034 77.5862H116.207V82.4138H121.034V77.5862Z",
    fill: "black"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M125.862 77.5862H121.034V82.4138H125.862V77.5862Z",
    fill: "black"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M130.69 77.5862H125.862V82.4138H130.69V77.5862Z",
    fill: "black"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M140.345 77.5862H135.517V82.4138H140.345V77.5862Z",
    fill: "black"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M150 77.5862H145.172V82.4138H150V77.5862Z",
    fill: "black"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M14.8276 82.4138H10V87.2414H14.8276V82.4138Z",
    fill: "black"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M24.4828 82.4138H19.6552V87.2414H24.4828V82.4138Z",
    fill: "black"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M34.1379 82.4138H29.3103V87.2414H34.1379V82.4138Z",
    fill: "black"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M38.9655 82.4138H34.1379V87.2414H38.9655V82.4138Z",
    fill: "black"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M48.6207 82.4138H43.7931V87.2414H48.6207V82.4138Z",
    fill: "black"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M63.1035 82.4138H58.2759V87.2414H63.1035V82.4138Z",
    fill: "black"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M72.7586 82.4138H67.931V87.2414H72.7586V82.4138Z",
    fill: "black"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M87.2414 82.4138H82.4138V87.2414H87.2414V82.4138Z",
    fill: "black"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M101.724 82.4138H96.8966V87.2414H101.724V82.4138Z",
    fill: "black"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M111.379 82.4138H106.552V87.2414H111.379V82.4138Z",
    fill: "black"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M125.862 82.4138H121.034V87.2414H125.862V82.4138Z",
    fill: "black"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M140.345 82.4138H135.517V87.2414H140.345V82.4138Z",
    fill: "black"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M145.172 82.4138H140.345V87.2414H145.172V82.4138Z",
    fill: "black"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M14.8276 87.2414H10V92.069H14.8276V87.2414Z",
    fill: "black"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M19.6552 87.2414H14.8276V92.069H19.6552V87.2414Z",
    fill: "black"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M24.4828 87.2414H19.6552V92.069H24.4828V87.2414Z",
    fill: "black"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M29.3103 87.2414H24.4828V92.069H29.3103V87.2414Z",
    fill: "black"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M34.1379 87.2414H29.3103V92.069H34.1379V87.2414Z",
    fill: "black"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M38.9655 87.2414H34.1379V92.069H38.9655V87.2414Z",
    fill: "black"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M43.7931 87.2414H38.9655V92.069H43.7931V87.2414Z",
    fill: "black"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M48.6207 87.2414H43.7931V92.069H48.6207V87.2414Z",
    fill: "black"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M58.2759 87.2414H53.4483V92.069H58.2759V87.2414Z",
    fill: "black"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M63.1035 87.2414H58.2759V92.069H63.1035V87.2414Z",
    fill: "black"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M67.931 87.2414H63.1035V92.069H67.931V87.2414Z",
    fill: "black"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M72.7586 87.2414H67.931V92.069H72.7586V87.2414Z",
    fill: "black"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M77.5862 87.2414H72.7586V92.069H77.5862V87.2414Z",
    fill: "black"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M82.4138 87.2414H77.5862V92.069H82.4138V87.2414Z",
    fill: "black"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M92.069 87.2414H87.2414V92.069H92.069V87.2414Z",
    fill: "black"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M96.8966 87.2414H92.069V92.069H96.8966V87.2414Z",
    fill: "black"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M111.379 87.2414H106.552V92.069H111.379V87.2414Z",
    fill: "black"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M130.69 87.2414H125.862V92.069H130.69V87.2414Z",
    fill: "black"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M19.6552 92.069H14.8276V96.8966H19.6552V92.069Z",
    fill: "black"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M29.3103 92.069H24.4828V96.8966H29.3103V92.069Z",
    fill: "black"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M34.1379 92.069H29.3103V96.8966H34.1379V92.069Z",
    fill: "black"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M53.4483 92.069H48.6207V96.8966H53.4483V92.069Z",
    fill: "black"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M58.2759 92.069H53.4483V96.8966H58.2759V92.069Z",
    fill: "black"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M67.931 92.069H63.1035V96.8966H67.931V92.069Z",
    fill: "black"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M77.5862 92.069H72.7586V96.8966H77.5862V92.069Z",
    fill: "black"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M111.379 92.069H106.552V96.8966H111.379V92.069Z",
    fill: "black"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M125.862 92.069H121.034V96.8966H125.862V92.069Z",
    fill: "black"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M135.517 92.069H130.69V96.8966H135.517V92.069Z",
    fill: "black"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M14.8276 96.8966H10V101.724H14.8276V96.8966Z",
    fill: "black"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M24.4828 96.8966H19.6552V101.724H24.4828V96.8966Z",
    fill: "black"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M34.1379 96.8966H29.3103V101.724H34.1379V96.8966Z",
    fill: "black"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M38.9655 96.8966H34.1379V101.724H38.9655V96.8966Z",
    fill: "black"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M43.7931 96.8966H38.9655V101.724H43.7931V96.8966Z",
    fill: "black"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M58.2759 96.8966H53.4483V101.724H58.2759V96.8966Z",
    fill: "black"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M77.5862 96.8966H72.7586V101.724H77.5862V96.8966Z",
    fill: "black"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M92.069 96.8966H87.2414V101.724H92.069V96.8966Z",
    fill: "black"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M96.8966 96.8966H92.069V101.724H96.8966V96.8966Z",
    fill: "black"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M106.552 96.8966H101.724V101.724H106.552V96.8966Z",
    fill: "black"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M116.207 96.8966H111.379V101.724H116.207V96.8966Z",
    fill: "black"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M121.034 96.8966H116.207V101.724H121.034V96.8966Z",
    fill: "black"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M125.862 96.8966H121.034V101.724H125.862V96.8966Z",
    fill: "black"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M135.517 96.8966H130.69V101.724H135.517V96.8966Z",
    fill: "black"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M140.345 96.8966H135.517V101.724H140.345V96.8966Z",
    fill: "black"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M145.172 96.8966H140.345V101.724H145.172V96.8966Z",
    fill: "black"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M150 96.8966H145.172V101.724H150V96.8966Z",
    fill: "black"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M19.6552 101.724H14.8276V106.552H19.6552V101.724Z",
    fill: "black"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M24.4828 101.724H19.6552V106.552H24.4828V101.724Z",
    fill: "black"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M29.3103 101.724H24.4828V106.552H29.3103V101.724Z",
    fill: "black"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M34.1379 101.724H29.3103V106.552H34.1379V101.724Z",
    fill: "black"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M48.6207 101.724H43.7931V106.552H48.6207V101.724Z",
    fill: "black"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M53.4483 101.724H48.6207V106.552H53.4483V101.724Z",
    fill: "black"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M58.2759 101.724H53.4483V106.552H58.2759V101.724Z",
    fill: "black"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M82.4138 101.724H77.5862V106.552H82.4138V101.724Z",
    fill: "black"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M87.2414 101.724H82.4138V106.552H87.2414V101.724Z",
    fill: "black"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M96.8966 101.724H92.069V106.552H96.8966V101.724Z",
    fill: "black"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M101.724 101.724H96.8966V106.552H101.724V101.724Z",
    fill: "black"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M106.552 101.724H101.724V106.552H106.552V101.724Z",
    fill: "black"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M111.379 101.724H106.552V106.552H111.379V101.724Z",
    fill: "black"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M121.034 101.724H116.207V106.552H121.034V101.724Z",
    fill: "black"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M125.862 101.724H121.034V106.552H125.862V101.724Z",
    fill: "black"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M130.69 101.724H125.862V106.552H130.69V101.724Z",
    fill: "black"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M135.517 101.724H130.69V106.552H135.517V101.724Z",
    fill: "black"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M150 101.724H145.172V106.552H150V101.724Z",
    fill: "black"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M14.8276 106.552H10V111.379H14.8276V106.552Z",
    fill: "black"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M43.7931 106.552H38.9655V111.379H43.7931V106.552Z",
    fill: "black"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M53.4483 106.552H48.6207V111.379H53.4483V106.552Z",
    fill: "black"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M72.7586 106.552H67.931V111.379H72.7586V106.552Z",
    fill: "black"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M87.2414 106.552H82.4138V111.379H87.2414V106.552Z",
    fill: "black"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M96.8966 106.552H92.069V111.379H96.8966V106.552Z",
    fill: "black"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M106.552 106.552H101.724V111.379H106.552V106.552Z",
    fill: "black"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M111.379 106.552H106.552V111.379H111.379V106.552Z",
    fill: "black"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M116.207 106.552H111.379V111.379H116.207V106.552Z",
    fill: "black"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M121.034 106.552H116.207V111.379H121.034V106.552Z",
    fill: "black"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M125.862 106.552H121.034V111.379H125.862V106.552Z",
    fill: "black"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M130.69 106.552H125.862V111.379H130.69V106.552Z",
    fill: "black"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M135.517 106.552H130.69V111.379H135.517V106.552Z",
    fill: "black"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M150 106.552H145.172V111.379H150V106.552Z",
    fill: "black"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M53.4483 111.379H48.6207V116.207H53.4483V111.379Z",
    fill: "black"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M58.2759 111.379H53.4483V116.207H58.2759V111.379Z",
    fill: "black"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M63.1035 111.379H58.2759V116.207H63.1035V111.379Z",
    fill: "black"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M67.931 111.379H63.1035V116.207H67.931V111.379Z",
    fill: "black"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M87.2414 111.379H82.4138V116.207H87.2414V111.379Z",
    fill: "black"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M111.379 111.379H106.552V116.207H111.379V111.379Z",
    fill: "black"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M130.69 111.379H125.862V116.207H130.69V111.379Z",
    fill: "black"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M135.517 111.379H130.69V116.207H135.517V111.379Z",
    fill: "black"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M140.345 111.379H135.517V116.207H140.345V111.379Z",
    fill: "black"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M14.8276 116.207H10V121.034H14.8276V116.207Z",
    fill: "black"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M19.6552 116.207H14.8276V121.034H19.6552V116.207Z",
    fill: "black"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M24.4828 116.207H19.6552V121.034H24.4828V116.207Z",
    fill: "black"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M29.3103 116.207H24.4828V121.034H29.3103V116.207Z",
    fill: "black"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M34.1379 116.207H29.3103V121.034H34.1379V116.207Z",
    fill: "black"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M38.9655 116.207H34.1379V121.034H38.9655V116.207Z",
    fill: "black"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M43.7931 116.207H38.9655V121.034H43.7931V116.207Z",
    fill: "black"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M72.7586 116.207H67.931V121.034H72.7586V116.207Z",
    fill: "black"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M77.5862 116.207H72.7586V121.034H77.5862V116.207Z",
    fill: "black"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M111.379 116.207H106.552V121.034H111.379V116.207Z",
    fill: "black"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M121.034 116.207H116.207V121.034H121.034V116.207Z",
    fill: "black"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M130.69 116.207H125.862V121.034H130.69V116.207Z",
    fill: "black"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M14.8276 121.034H10V125.862H14.8276V121.034Z",
    fill: "black"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M43.7931 121.034H38.9655V125.862H43.7931V121.034Z",
    fill: "black"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M58.2759 121.034H53.4483V125.862H58.2759V121.034Z",
    fill: "black"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M63.1035 121.034H58.2759V125.862H63.1035V121.034Z",
    fill: "black"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M72.7586 121.034H67.931V125.862H72.7586V121.034Z",
    fill: "black"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M82.4138 121.034H77.5862V125.862H82.4138V121.034Z",
    fill: "black"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M87.2414 121.034H82.4138V125.862H87.2414V121.034Z",
    fill: "black"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M106.552 121.034H101.724V125.862H106.552V121.034Z",
    fill: "black"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M111.379 121.034H106.552V125.862H111.379V121.034Z",
    fill: "black"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M130.69 121.034H125.862V125.862H130.69V121.034Z",
    fill: "black"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M135.517 121.034H130.69V125.862H135.517V121.034Z",
    fill: "black"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M140.345 121.034H135.517V125.862H140.345V121.034Z",
    fill: "black"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M145.172 121.034H140.345V125.862H145.172V121.034Z",
    fill: "black"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M14.8276 125.862H10V130.69H14.8276V125.862Z",
    fill: "black"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M24.4828 125.862H19.6552V130.69H24.4828V125.862Z",
    fill: "black"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M29.3103 125.862H24.4828V130.69H29.3103V125.862Z",
    fill: "black"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M34.1379 125.862H29.3103V130.69H34.1379V125.862Z",
    fill: "black"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M43.7931 125.862H38.9655V130.69H43.7931V125.862Z",
    fill: "black"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M53.4483 125.862H48.6207V130.69H53.4483V125.862Z",
    fill: "black"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M58.2759 125.862H53.4483V130.69H58.2759V125.862Z",
    fill: "black"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M77.5862 125.862H72.7586V130.69H77.5862V125.862Z",
    fill: "black"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M87.2414 125.862H82.4138V130.69H87.2414V125.862Z",
    fill: "black"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M96.8966 125.862H92.069V130.69H96.8966V125.862Z",
    fill: "black"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M106.552 125.862H101.724V130.69H106.552V125.862Z",
    fill: "black"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M111.379 125.862H106.552V130.69H111.379V125.862Z",
    fill: "black"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M116.207 125.862H111.379V130.69H116.207V125.862Z",
    fill: "black"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M121.034 125.862H116.207V130.69H121.034V125.862Z",
    fill: "black"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M125.862 125.862H121.034V130.69H125.862V125.862Z",
    fill: "black"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M130.69 125.862H125.862V130.69H130.69V125.862Z",
    fill: "black"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M140.345 125.862H135.517V130.69H140.345V125.862Z",
    fill: "black"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M150 125.862H145.172V130.69H150V125.862Z",
    fill: "black"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M14.8276 130.69H10V135.517H14.8276V130.69Z",
    fill: "black"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M24.4828 130.69H19.6552V135.517H24.4828V130.69Z",
    fill: "black"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M29.3103 130.69H24.4828V135.517H29.3103V130.69Z",
    fill: "black"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M34.1379 130.69H29.3103V135.517H34.1379V130.69Z",
    fill: "black"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M43.7931 130.69H38.9655V135.517H43.7931V130.69Z",
    fill: "black"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M67.931 130.69H63.1035V135.517H67.931V130.69Z",
    fill: "black"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M77.5862 130.69H72.7586V135.517H77.5862V130.69Z",
    fill: "black"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M92.069 130.69H87.2414V135.517H92.069V130.69Z",
    fill: "black"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M101.724 130.69H96.8966V135.517H101.724V130.69Z",
    fill: "black"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M106.552 130.69H101.724V135.517H106.552V130.69Z",
    fill: "black"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M111.379 130.69H106.552V135.517H111.379V130.69Z",
    fill: "black"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M116.207 130.69H111.379V135.517H116.207V130.69Z",
    fill: "black"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M121.034 130.69H116.207V135.517H121.034V130.69Z",
    fill: "black"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M130.69 130.69H125.862V135.517H130.69V130.69Z",
    fill: "black"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M145.172 130.69H140.345V135.517H145.172V130.69Z",
    fill: "black"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M150 130.69H145.172V135.517H150V130.69Z",
    fill: "black"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M14.8276 135.517H10V140.345H14.8276V135.517Z",
    fill: "black"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M24.4828 135.517H19.6552V140.345H24.4828V135.517Z",
    fill: "black"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M29.3103 135.517H24.4828V140.345H29.3103V135.517Z",
    fill: "black"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M34.1379 135.517H29.3103V140.345H34.1379V135.517Z",
    fill: "black"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M43.7931 135.517H38.9655V140.345H43.7931V135.517Z",
    fill: "black"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M53.4483 135.517H48.6207V140.345H53.4483V135.517Z",
    fill: "black"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M58.2759 135.517H53.4483V140.345H58.2759V135.517Z",
    fill: "black"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M63.1035 135.517H58.2759V140.345H63.1035V135.517Z",
    fill: "black"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M77.5862 135.517H72.7586V140.345H77.5862V135.517Z",
    fill: "black"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M82.4138 135.517H77.5862V140.345H82.4138V135.517Z",
    fill: "black"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M87.2414 135.517H82.4138V140.345H87.2414V135.517Z",
    fill: "black"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M96.8966 135.517H92.069V140.345H96.8966V135.517Z",
    fill: "black"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M106.552 135.517H101.724V140.345H106.552V135.517Z",
    fill: "black"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M111.379 135.517H106.552V140.345H111.379V135.517Z",
    fill: "black"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M140.345 135.517H135.517V140.345H140.345V135.517Z",
    fill: "black"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M145.172 135.517H140.345V140.345H145.172V135.517Z",
    fill: "black"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M14.8276 140.345H10V145.172H14.8276V140.345Z",
    fill: "black"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M43.7931 140.345H38.9655V145.172H43.7931V140.345Z",
    fill: "black"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M53.4483 140.345H48.6207V145.172H53.4483V140.345Z",
    fill: "black"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M58.2759 140.345H53.4483V145.172H58.2759V140.345Z",
    fill: "black"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M77.5862 140.345H72.7586V145.172H77.5862V140.345Z",
    fill: "black"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M96.8966 140.345H92.069V145.172H96.8966V140.345Z",
    fill: "black"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M111.379 140.345H106.552V145.172H111.379V140.345Z",
    fill: "black"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M135.517 140.345H130.69V145.172H135.517V140.345Z",
    fill: "black"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M140.345 140.345H135.517V145.172H140.345V140.345Z",
    fill: "black"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M14.8276 145.172H10V150H14.8276V145.172Z",
    fill: "black"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M19.6552 145.172H14.8276V150H19.6552V145.172Z",
    fill: "black"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M24.4828 145.172H19.6552V150H24.4828V145.172Z",
    fill: "black"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M29.3103 145.172H24.4828V150H29.3103V145.172Z",
    fill: "black"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M34.1379 145.172H29.3103V150H34.1379V145.172Z",
    fill: "black"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M38.9655 145.172H34.1379V150H38.9655V145.172Z",
    fill: "black"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M43.7931 145.172H38.9655V150H43.7931V145.172Z",
    fill: "black"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M53.4483 145.172H48.6207V150H53.4483V145.172Z",
    fill: "black"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M67.931 145.172H63.1035V150H67.931V145.172Z",
    fill: "black"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M72.7586 145.172H67.931V150H72.7586V145.172Z",
    fill: "black"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M77.5862 145.172H72.7586V150H77.5862V145.172Z",
    fill: "black"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M82.4138 145.172H77.5862V150H82.4138V145.172Z",
    fill: "black"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M87.2414 145.172H82.4138V150H87.2414V145.172Z",
    fill: "black"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M101.724 145.172H96.8966V150H101.724V145.172Z",
    fill: "black"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M140.345 145.172H135.517V150H140.345V145.172Z",
    fill: "black"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M145.172 145.172H140.345V150H145.172V145.172Z",
    fill: "black"
  }))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "clip0_613_20443"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 160,
    height: 160,
    fill: "white"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgQrCode);
export default __webpack_public_path__ + "static/media/QRCode.8ffe1882b2b59470a9dc42c2a4545566.svg";
export { ForwardRef as ReactComponent };